// src/pages/restaurant/EditMenu.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import api from "../../utils/api";
import AdvancedMenuForm from "../../components/restaurant/menu/AdvancedMenuForm";
import SimpleMenuForm from "../../components/restaurant/menu/SimpleMenuForm";
import AdvancedMenuFormEdit from "../../components/restaurant/menu/AdvancedMenuEditForm";
import SimpleMenuFormEdit from "../../components/restaurant/menu/SimpleMenuFormEdit";
import AdvancedMenuFormEditStaff from "../StaffLogin/MenuForms/AdvancedMenuEditFormStaff";
import SimpleMenuFormEditStaff from "../StaffLogin/MenuForms/SimpleMenuFormEditStaff";

const EditMenu = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const menuId = searchParams.get("id");

  const [inventory, setInventory] = useState([]);
  const [menuData, setMenuData] = useState(null); // This holds fetched menu details
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("simple");

  // Fetch inventory
  useEffect(() => {
    api
      .get("restaurant/inventory/get")
      .then((res) => {
        setInventory(res.data?.inventory || []);
      })
      .catch(console.error);
  }, []);

  // Fetch menu data by ID
  useEffect(() => {
    if (!menuId) return;

    setLoading(true);
    api
      .get(`restaurant/restaurant/menu/all?menuId=${menuId}`)
      .then((res) => {
        setMenuData(res.data || null);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [menuId]);

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex items-center gap-4 mb-6">
        <button onClick={() => navigate(-1)} className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors" title="Back to Menus">
          <FaArrowLeft />
        </button>
        <h2 className="text-3xl font-bold">Edit Menu</h2>
      </div>

      {/* Tabs */}
      <div className="flex space-x-4 mb-6 border-b">
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "simple"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("simple")}
        >
          Simple
        </button>
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "advanced"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("advanced")}
        >
          Advanced
        </button>
      </div>

      {/* Content */}
      {window.location.pathname.includes("/restaurant-staff") ? (
        selectedTab === "simple" ? (
          <SimpleMenuFormEditStaff inventory={inventory} menuData={menuData} />
        ) : (
          <AdvancedMenuFormEditStaff inventory={inventory} menuData={menuData} />
        )
      ) : (
        selectedTab === "simple" ? (
          <SimpleMenuFormEdit inventory={inventory} menuData={menuData} />
        ) : (
          <AdvancedMenuFormEdit inventory={inventory} menuData={menuData} />
        )
      )}
    </div>
  );
};

export default EditMenu;
